export default "__VITE_ASSET__HiQwtkP5__"